// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;&#145;You shall break them with a rod of iron&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and dash them in pieces like a potter&#146;s vessel.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;